import { ReactComponent as EngageIcon } from "css/images/svg/engage.svg";
import { ReactComponent as MultiSourceIcon } from "css/images/svg/multi-source.svg";
import { ReactComponent as UnifiedWorkflowIcon } from "css/images/svg/unified-workflow.svg";
import { Link } from "react-router-dom";
import { Button } from "../shared/button";
import { HomeContentContainer } from "../shared/homeContentContainer";
import { LegalLinks } from "../shared/legalLinks";
import { HomeNavbar } from "../shared/navbar";
import { PlayVideoButton } from "../shared/playVideoButton";
import propOverviewImgMobile from "./assets/Mobile_Pop_Prop.png";
import poolImg from "./assets/pool-image-800.jpg";
import propAvmImg from "./assets/Pop_avm.png";
import propEquityImg from "./assets/Pop_equity.png";
import propOverviewImgDesktop from "./assets/Pop_Prop.png";
import styles from "./styles.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay } from "@fortawesome/pro-regular-svg-icons";

export function HomePage() {
  const handleGoToNewFlueidPro = () => {
    window.open("https://new.pro.flueid.com/", "_blank");
  };

  return (
    <HomeContentContainer>
      <HomeNavbar />
      <main className={styles.main}>
        <section className={styles.left_section}>
          <h1 className={styles.hero_header}>
            The new Flueid <br /> Pro is here. <br />{" "}
          </h1>
          <div className={styles.info_wrapper}>
            <p>
              Smarter property research and lead discovery in one modern experience that is built for title providers,
              their teams and the clients they serve.
            </p>
            <div className={styles.title_details_separator_line} />
          </div>
          <div className={styles.whats_new_section}>
            <div className={styles.whats_new_header_wrapper}>
              <h4 className={styles.whats_new_header}>What's new?</h4>
              <Link to="/promo-video" className={styles.promo_video_link_mobile}>
                <FontAwesomeIcon icon={faCirclePlay} className="txt-primary" size="3x" />
              </Link>
            </div>
            <ul className={styles.features_list}>
              <li className={styles.feature_item}>
                <span className={styles.feature_icon_wrapper}>
                  <UnifiedWorkflowIcon className={styles.feature_icon} />
                </span>
                <p>One connected way to work that replaces multiple tools with an upgraded, user-friendly interface.</p>
              </li>
              <li className={styles.feature_item}>
                <span className={styles.feature_icon_wrapper}>
                  <MultiSourceIcon className={styles.feature_icon} />
                </span>
                <p>Improved nationwide coverage with multi-source data to give you a complete view of any property.</p>
              </li>
              <li className={styles.feature_item}>
                <span className={styles.feature_icon_wrapper}>
                  <EngageIcon className={styles.feature_icon} />
                </span>
                <p>
                  Enhanced farm features and marketing tools that helps you move from research to outreach faster than
                  ever.
                </p>
              </li>
            </ul>
          </div>
          <Button primary className={styles.go_to_button} onClick={handleGoToNewFlueidPro}>
            Go to the new Flueid Pro
          </Button>
          <footer className={styles.footer_desktop}>
            <LegalLinks />
          </footer>
        </section>
        <section className={styles.right_section}>
          <img className={styles.promo_img_desktop} src={poolImg} />
          <div className={styles.promo_img_mobile_wrapper}>
            <img className={styles.promo_img_mobile} src={poolImg} />
          </div>
          <div className={styles.widgets_grid}>
            <img className={styles.prop_overview_img_desktop} src={propOverviewImgDesktop} />
            <img className={styles.prop_overview_img_mobile} src={propOverviewImgMobile} />
            <img className={styles.prop_avm_img} src={propAvmImg} />
            <img className={styles.prop_equity_img} src={propEquityImg} />
          </div>
          <Link to="/promo-video" className={styles.promo_video_link}>
            <PlayVideoButton />
          </Link>
        </section>
      </main>
      <div className={styles.vertical_brand_line}></div>
      <footer className={styles.footer_mobile}>
        <LegalLinks />
      </footer>
    </HomeContentContainer>
  );
}
